import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Nav, NavItem, NavbarToggler, Navbar, Collapse } from 'reactstrap';
import { NavLink } from 'react-router-dom';
import { isMobile } from 'react-device-detect';
import { ProfileNavigationHeader } from './ProfileNavigationHeader';
import { PROFILE_ROUTES } from './Profile';
import { useDispatch } from 'react-redux';
import { loadUserSubscriptions } from 'redux/actions';

const ProfileNavItem = ({ id, to, children, onClick }) => (
  <NavItem>
    <NavLink to={to} className="profile-nav-link" activeClassName="active" id={id} onClick={onClick}>
      <span>{children}</span>
    </NavLink>
  </NavItem>
);

ProfileNavItem.propTypes = {
  id: PropTypes.string,
  to: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  onClick: PropTypes.func.isRequired
};

export const ProfileNavigation = () => {
  const [isOpen, setIsOpen] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(loadUserSubscriptions());
  }, []);

  const handleOnToggleMenu = () => {
    if (isMobile) {
      setIsOpen(!isOpen);
    }
  };

  return (
    <div className="profile-navigation">
      <ProfileNavigationHeader />
      <Navbar expand="md" className="submenu m-0 p-0">
        <NavbarToggler className="d-flex d-md-none justify-content-end me-2 me-sm-3" onClick={handleOnToggleMenu}>
          <div className={`submenu-toggler${isOpen ? ' rotate' : ''}`} />
        </NavbarToggler>
        <Collapse isOpen={isOpen} navbar>
          <Nav>
            <ProfileNavItem onClick={handleOnToggleMenu} to={PROFILE_ROUTES.personalData}>
              Persönliche Daten
            </ProfileNavItem>
            <ProfileNavItem onClick={handleOnToggleMenu} to={PROFILE_ROUTES.subscriptionStatus}>
              Dein Abo
            </ProfileNavItem>
            <ProfileNavItem onClick={handleOnToggleMenu} to={PROFILE_ROUTES.attendances}>
              Deine Freischaltung
            </ProfileNavItem>
            <ProfileNavItem onClick={handleOnToggleMenu} to={PROFILE_ROUTES.invoices}>
              Deine Rechnungen
            </ProfileNavItem>
            <ProfileNavItem onClick={handleOnToggleMenu} to={PROFILE_ROUTES.specialFeature}>
              Specials freischalten
            </ProfileNavItem>
            <ProfileNavItem onClick={handleOnToggleMenu} to={PROFILE_ROUTES.help}>
              Hilfe
            </ProfileNavItem>
          </Nav>
        </Collapse>
      </Navbar>
    </div>
  );
};
